"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapSelectPreset = exports.WidgetName = exports.InstanceWrapper = exports.InstanceHeader = exports.InstanceBlock = exports.Accordion = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
exports.Accordion = (0, styled_components_1.default)(wl_ui_kit_1.StyledSvgAccordion) `
  cursor: pointer;
`;
exports.InstanceBlock = styled_components_1.default.div `
  padding: ${(0, wl_ui_kit_1.getSizeBy)(3)} 0 0 0;
`;
exports.InstanceHeader = styled_components_1.default.div `
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: ${({ $withoutAccordion = false }) => $withoutAccordion ? '1fr auto' : 'auto 1fr auto'};
  gap: 0 ${(0, wl_ui_kit_1.getSizeBy)(2)};
  align-items: center;
`;
exports.InstanceWrapper = styled_components_1.default.div `
  margin-top: ${(0, wl_ui_kit_1.getSizeBy)(2)};
`;
exports.WidgetName = (0, styled_components_1.default)(wl_ui_kit_1.Body2) `
  color: ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'mediumEmphasis')};
  font-size: ${(0, wl_ui_kit_1.getSizeBy)(2)};
  line-height: ${(0, wl_ui_kit_1.getSizeBy)(3)};
`;
exports.WrapSelectPreset = styled_components_1.default.div `
  margin: ${(0, wl_ui_kit_1.getSizeBy)(2)} 0 ${(0, wl_ui_kit_1.getSizeBy)(5)};
`;
//# sourceMappingURL=styled.js.map